/**
 * P3-32: Transcendence 升级按钮（TranscendenceBtnController / BuildingStackableBtn）。
 */
import { useTranscendenceUpgradeButtonModel } from "./useReligionModel";
import { StackableButton } from "../../components/StackableButton";

interface TranscendenceUpgradeButtonProps {
  upgradeName: string;
}

export function TranscendenceUpgradeButton({ upgradeName }: TranscendenceUpgradeButtonProps) {
  const { snap, modelRef, controller, getTooltip } = useTranscendenceUpgradeButtonModel(upgradeName);

  if (!snap || !snap.visible) {
    return null;
  }

  return (
    <StackableButton
      snap={snap}
      controller={controller}
      getModel={() => modelRef.current}
      getTooltip={getTooltip}
    />
  );
}
